import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { trigger, state, style, animate, transition, AnimationEvent } from '@angular/animations';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { Toast } from './class/toast';

@Component({
  selector: 'uex-toast',
  templateUrl: './toast.component.html',
  host: {
    'class': 'uex-toast',
    '[style.z-index]': 'getZIndex()',
    '[@toast]': 'getState()',
    '(@toast.start)': 'animationStart($event)',
    '(@toast.done)': 'animationEnd($event)'
  },
  animations: [
    trigger('toast', [
      state('initial', style({transform: 'translateY(0)', opacity: 0})),
      state('hidden', style({transform: 'translateY(0)', opacity: 0})),
      state('shown', style({transform: 'translateY(-100%)', opacity: 1})),
      transition('hidden => shown', animate('.1s')),
      transition('shown => hidden', animate('.1s'))
    ])
  ]
})
export class ToastComponent implements OnInit, OnDestroy {
  @Input('toast') private _toast: Toast;

  constructor() { }

  public ready = false;

  public get visible(): boolean { return this._toast.visible; }
  public get message(): string { return (<string>this._toast.message); }
  public get show_close_button(): boolean { return this._toast.show_close_button; }
  public get close_button_text(): string { return (<string>this._toast.close_button_text); }

  private _show_subscription: Subscription;
  private _show_timeout: any;

  public ngOnInit() {
    this.ready = true;

    this._show_subscription = this._toast.onShow.subscribe(() => {
      if (this._show_timeout) { clearTimeout(this._show_timeout); }

      if (this._toast.duration > 0) {
        this._show_timeout = setTimeout(() => this.close(), this._toast.duration);
      }
    });
  }

  public ngOnDestroy() {
    if (this._show_subscription) { this._show_subscription.unsubscribe(); }
    if (this._show_timeout) { clearTimeout(this._show_timeout); }
  }

  public animationStart(event: AnimationEvent) {
    if (event.fromState == 'shown' && event.toState == 'hidden') { this._toast.onHide.emit(); }
  }

  public animationEnd(event: AnimationEvent) {
    if (event.fromState == 'hidden' && event.toState == 'shown') { this._toast.onShown.emit(); }
    if (event.fromState == 'shown' && event.toState == 'hidden') { this._toast.onHidden.emit(); }
  }

  public getState(): string {
    return this.ready ? (this._toast.visible ? 'shown' : 'hidden') : 'initial';
  }

  public getZIndex(): number {
    return 11000 + (this._toast.id * 10);
  }

  public close() {
    if (this._toast.close_behavior == 'dismiss') {
      this._toast.hide();
    } else {
      this._toast.destroy();
    }
  }
}
